module.exports = __webpack_public_path__ + "static/media/breakfast.b2a6bcff.jpeg";